import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import Button from '../../../../designSystem/Button/Button';
import { api } from '../../../../../utils/api/api';
import { useMutation, useQueryClient } from 'react-query';
import { REGISTER_DOCUMENT_QUERY_KEY, queryUploadKBIS } from './RegisterDocumentsStep.query';
import { RegisterResponse } from '../../../../../types/api/endpoints/auth/register.types';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useCurrentUser } from '../../../../../hooks/useCurrentUser/useCurrentUser';
import { User } from '../../../../../types/models/user/user.types';
import { setProfile } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import moment from 'moment';
import { getStepIdFromENTStep } from '../../../../../utils/helpers/user/getStep';
import { RegisterStepsList } from '../RegisterSteps.types';
import { ButtonColor } from '../../../../designSystem/Button/Button.types';
import RegisterStepButton from '../../../../commons/RegisterStepButton/RegisterStepButton';

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie, removeCookie] = useCookies(['token']);

  const currentUser = useCurrentUser() as User;

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: {
      // 'image/*': ['.png', '.jpg', '.jpeg'],
      'application/pdf': ['.pdf'],
    },
  });

  const { mutate } = useMutation<Awaited<RegisterResponse>, Error, FormData>(
    (data) => queryUploadKBIS(data),
    {
      mutationKey: REGISTER_DOCUMENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: async ({ accessToken }) => {
        api.setHeader('authorization', `Bearer ${accessToken}`);
        removeCookie('token', { path: '/' });
        setCookie('token', accessToken, {
          expires: moment().add(60, 'minutes').toDate(),
          path: '/',
        });
        setProfile({ ...currentUser, id_step: getStepIdFromENTStep(RegisterStepsList.Documents) })(
          dispatch
        );
      },
      onError: async (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = useCallback(() => {
    const formData = new FormData();
    for (const file of acceptedFiles) {
      formData.append('files', file);
    }
    mutate(formData);
  }, [acceptedFiles]);

  return (
    <form className="form">
      <div {...getRootProps({ className: 'dropzone register__dropzone' })}>
        <input {...getInputProps()} />
        <p>Glissez votre KBIS ici</p>
        {acceptedFiles.length > 0 && <span>{acceptedFiles[0].name}</span>}
      </div>
      <RegisterStepButton isCompany />
      <Button
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        disabled={acceptedFiles.length === 0}
        color={ButtonColor.Secondary}>
        Soumettre
      </Button>
    </form>
  );
};
